import styled from 'styled-components';
import { FullWidth } from 'ui/utility/fullWidth';
import { EmptyState } from 'ui/emptyState';
import { colors, spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';
import { PageHeader } from 'ui/pageHeader';

export const Container = styled.div`
  width: 100%;
  max-width: ${spacing.normalPageMaxWidth};
  margin: 0 auto;
`;

export const FullWidthBody = styled(FullWidth)`
  flex-grow: 1;
  padding: 0 ${spacing.layoutLRPadding} ${spacing.double};
  margin-top: -${spacing.layoutTopPadding};
  background-color: ${({ theme }) => theme.colors.backgroundColors.backgroundSecondary};
`;

export const StyledEmptyState = styled(EmptyState)`
  min-height: ${pxToRem(300)};
  justify-content: center;
  background-color: ${colors.white};
`;

export const StyledPageHeader = styled(PageHeader)`
  margin-top: ${spacing.doubleQuarter};
  margin-bottom: ${spacing.doubleQuarter};
`;
